// informed splits keys using a regex to form a
// traversal path that is applied to the form state
// so we need to encode the key to ensure we do not
// inadvertedly trigger the traversal path split
// node_modules/informed/dist/esm/index.js > [ldtoPath]
export const SPECIAL_CHARS_TO_ENCODE = {
  ',': '_COMMA_',
  '.': '_DOT_',
  '[': '_LEFTBRACE_',
  ']': '_RIGHTBRACE_'
};

const encodeCustomAttributeKeyForForm = (key: string) => {
  return Object.keys(SPECIAL_CHARS_TO_ENCODE).reduce((acc, char) => {
    const encodedChar =
      SPECIAL_CHARS_TO_ENCODE[char as keyof typeof SPECIAL_CHARS_TO_ENCODE];
    return acc.replace(new RegExp(`\\${char}`, 'g'), encodedChar);
  }, key);
};

const decodeCustomAttributeKeyForForm = (key: string) => {
  return Object.keys(SPECIAL_CHARS_TO_ENCODE).reduce((acc, char) => {
    const encodedChar =
      SPECIAL_CHARS_TO_ENCODE[char as keyof typeof SPECIAL_CHARS_TO_ENCODE];
    return acc.replace(new RegExp(encodedChar, 'g'), char);
  }, key);
};

export { encodeCustomAttributeKeyForForm, decodeCustomAttributeKeyForForm };
